/**
 * useColetivoForBusiness — shared cache for "Membro de coletivo" badge.
 * Mesmo padrão de useCampanhaForBusiness: 1 fetch/município, cache 60s.
 */
import { useEffect, useState } from 'react';
import { api } from '../services/api';

const CACHE = new Map();
const PENDING = new Map();
const TTL_MS = 60 * 1000;

async function fetchMap(municipioSlug) {
  const key = municipioSlug || '__all__';
  const cached = CACHE.get(key);
  if (cached && Date.now() - cached.ts < TTL_MS) return cached.businesses;
  if (PENDING.has(key)) return PENDING.get(key);
  const p = (async () => {
    try {
      const params = municipioSlug ? { municipio_slug: municipioSlug } : {};
      const r = await api.get('/v2/coletivos/active-businesses', { params });
      const businesses = r.data?.businesses || {};
      CACHE.set(key, { ts: Date.now(), businesses });
      return businesses;
    } catch {
      CACHE.set(key, { ts: Date.now(), businesses: {} });
      return {};
    } finally {
      PENDING.delete(key);
    }
  })();
  PENDING.set(key, p);
  return p;
}

export function useColetivoForBusiness(businessId, municipioSlug) {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    let alive = true;
    if (!businessId) return undefined;
    fetchMap(municipioSlug).then((map) => {
      if (alive) setInfo(map[businessId] || null);
    });
    return () => { alive = false; };
  }, [businessId, municipioSlug]);
  return info;
}

export function invalidateColetivoCache() {
  CACHE.clear();
}
